var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7954_40164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6177 1.36133H2.72315C1.97415 1.36133 1.36814 1.97415 1.36814 2.72315L1.36133 14.9795L4.08497 12.2559H13.6177C14.3667 12.2559 14.9795 11.6431 14.9795 10.8941V2.72315C14.9795 1.97415 14.3667 1.36133 13.6177 1.36133ZM13.6177 10.8941H3.51982L3.11808 11.2958L2.72315 11.6907V2.72315H13.6177V10.8941ZM7.48952 8.17044H8.85135V9.53226H7.48952V8.17044ZM7.48952 4.08497H8.85135V6.80861H7.48952V4.08497Z",
    fill: "#2859C5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7954_40164"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.341,
    height: 16.341,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.faaa8cc3d01d4d81227f65a90f7e73ae.svg";
export { ForwardRef as ReactComponent };